// removed by extract-text-webpack-plugin
module.exports = {"root":"_1jHot-L","root_hasCount":"_30JpQpS","heading":"_32vd5I6","subheading":"_38FgSeV","count":"_2lV7-o9"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/HomePage/components/Dashboard/components/SignedInDashboard/components/DashboardItem/DashboardItem.less
 ** module id = 769
 ** module chunks = 0
 **/